// Product Insights KPI distinct-counts — the pure core of v3 `ProductInsightsCards.vue:66–133`
// (ORP-18953, contract 27 §3/§9). Semantics are v3-verbatim, including the subtle ORDER of the
// demand count: rows are deduped by `product_name` FIRST (keeping each name's first-seen row),
// and only then filtered on `relative_demand_change !== 'FLAT'` — a product whose first row is
// FLAT is excluded even if a later row rises. Pinned in the spec; do not "simplify" the order.

type Row = Record<string, unknown>

function countFirstOccurrences(rows: readonly Row[], field: string): number {
  const seen = new Set<unknown>()
  let count = 0
  for (const row of rows) {
    const value = row[field]
    if (seen.has(value)) continue
    seen.add(value)
    count += 1
  }
  return count
}

/** Distinct `product_id` on the (regex-filtered) issues response — "Products with Issues". */
export function countProductsWithIssues(rows: readonly Row[]): number {
  return countFirstOccurrences(rows, 'product_id')
}

/** Distinct `product_issue_type` on the same response — "Catalog Issue Types". */
export function countIssueTypes(rows: readonly Row[]): number {
  return countFirstOccurrences(rows, 'product_issue_type')
}

/** Dedupe by `product_name` (first occurrence), THEN count non-FLAT — "Demand Increased". */
export function countDemandIncreased(rows: readonly Row[]): number {
  const seen = new Set<unknown>()
  let count = 0
  for (const row of rows) {
    const name = row['product_name']
    if (seen.has(name)) continue
    seen.add(name)
    if (row['relative_demand_change'] !== 'FLAT') count += 1
  }
  return count
}
